
export const LIST_ITEM_HEADER = 'CollapsibleListItemHeader';
export const LIST_ITEM_BODY = 'CollapsibleListItemBody';
